<!--
 * @Author: Admni
 * @Description: 
 * @Date: 2021-01-30 10:40:50
 * @LastEditTime: 2021-03-03 10:55:02
-->
<template>
  <div id="set">
    <section class="tag-wrap">
      <h1>
        <span>Tag设置</span>
        <small>注：tag只能新增，不能删除</small>
      </h1>
      <div class="tag">
        <tag></tag>
      </div>
    </section>

    <section class="group-wrap">
      <h1>
        <span>分组设置</span>
        <small>管理分组</small>
      </h1>
      <div class="group">
        <el-button @click="dialogGroup = true">批量发送</el-button>
        <div
          v-for="(item, key, index) in groupAll"
          :key="index"
          class="group_wrap"
        >
          <div class="group_title">
            {{ key }}
            <span @click="removeGroup(key)"
              >删除分组 <i class="el-icon-delete"></i
            ></span>
          </div>
          <div class="group_table">
            <!-- {{ item }} -->
            <div class="group_lis head">
              <div class="group_li head">Id</div>
              <div class="group_li head">用户名</div>
              <div class="group_li head">包名</div>
            </div>
            <div v-for="(it, ind) in item" :key="ind" class="group_lis">
              <div class="group_li">{{ it.pk }}</div>
              <div class="group_li">{{ it.u_name }}</div>
              <div class="group_li">{{ it.pkg }}</div>
              <div class="group_li handler" @click="removeUser(key, ind)">
                移除用户 <i class="el-icon-delete"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="reply-wrap">
      <h1>
        <span>自动回复设置</span>
        <small>管理自动回复</small>
      </h1>
      <div class="table-wrap">
        <el-table
          :data="tableData"
          style="width: 100%"
          v-loading="loading"
          border
          :header-cell-style="{ background: '#ececf1', color: '#414750' }"
        >
          <el-table-column
            align="center"
            prop="pkg__pkg"
            label="包名"
            width="240"
          >
          </el-table-column>
          <el-table-column align="center" prop="msg_en" label="English">
          </el-table-column>
          <el-table-column align="center" prop="msg_cn" label="中文">
          </el-table-column>
          <el-table-column align="center" prop="msg_ar" label="العربية">
          </el-table-column>
          <el-table-column align="center" prop="msg_fr" label="En français">
          </el-table-column>
          <el-table-column align="center" prop="msg_in" label="हिंदी">
          </el-table-column>
          <el-table-column align="center" prop="msg_ja" label="日本語">
          </el-table-column>
          <el-table-column align="center" prop="msg_ko" label="한국어">
          </el-table-column>
          <el-table-column
            align="center"
            fixed="right"
            label="操作"
            width="200"
          >
            <template slot-scope="scope">
              <el-button
                @click="updateReply(scope.row)"
                type="text"
                size="small"
                >修改</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </section>

    <el-dialog
      title="批量发送"
      :visible.sync="dialogGroup"
      width="30%"
      top="5vh"
    >
      <el-form :model="form_group" label-position="left" label-width="80px">
        <el-form-item label="选择分组">
          <el-select v-model="form_group.value" placeholder="请选择">
            <el-option
              v-for="item in form_group.options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="消息">
          <el-input
            v-model="form_group.text"
            placeholder="请输入要发送的消息"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogGroup = false">取 消</el-button>
        <el-button type="primary" @click="addGroup">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="修改快捷回复"
      :visible.sync="dialogReply"
      width="30%"
      top="5vh"
    >
      <el-form :model="form" label-position="left" label-width="80px">
        <el-form-item label="英语">
          <el-input v-model="form.msg_en" placeholder="English"></el-input>
        </el-form-item>
        <el-form-item label="中文">
          <el-input v-model="form.msg_cn" placeholder="简体中文"></el-input>
        </el-form-item>
        <el-form-item label="阿拉伯语">
          <el-input v-model="form.msg_ar" placeholder="العربية"></el-input>
        </el-form-item>
        <el-form-item label="法语">
          <el-input v-model="form.msg_fr" placeholder="En français"></el-input>
        </el-form-item>
        <el-form-item label="印度语">
          <el-input v-model="form.msg_in" placeholder="हिंदी"></el-input>
        </el-form-item>
        <el-form-item label="日语">
          <el-input v-model="form.msg_ja" placeholder="日本語"></el-input>
        </el-form-item>
        <el-form-item label="韩语">
          <el-input v-model="form.msg_ko" placeholder="한국어"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogReply = false">取 消</el-button>
        <el-button type="primary" @click="addReply()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Tag from "./tags";
import {
  getAutoReplyList,
  updateAutoReply,
  updateSug,
  batchSendMsgs,
} from "@/api/chat";
import { parse } from "path-to-regexp";
export default {
  components: {
    Tag,
  },
  data() {
    return {
      dialogGroup: false,
      dialogReply: false,
      loading: false,
      groupData: [],
      form_group: {
        options: [],
        value: "",
        text: "",
      },
      groupAll: {},
      groupAllCopy: {},
      form: {
        msg_en: "",
        msg_cn: "",
        msg_ar: "",
        msg_fr: "",
        msg_in: "",
        msg_ja: "",
        msg_ko: "",
      },
      curReplyIndex: 0,
      tableData: [],
      lang: [
        //所有支持的语言
        "en",
        "cn",
        "ar",
        "in",
        "fr",
        "ja",
        "ko",
      ],
    };
  },

  mounted() {
    let all_pkg = JSON.parse(localStorage.getItem("pkg"));
    let list = [];
    all_pkg.forEach((item) => {
      list.push({
        pkg__pkg: item.pkg,
        pkg__pk: item.pk,
        msg_en: "",
        msg_cn: "",
        msg_ar: "",
        msg_fr: "",
        msg_in: "",
        msg_ja: "",
        msg_ko: "",
      });
    });

    this.tableData = list;
    this.initReplyData();

    // 分组
    this.groupAll = JSON.parse(localStorage.getItem("u_g"));
    this.groupAllCopy = JSON.parse(localStorage.getItem("u_g"));
    for (let key in this.groupAll) {
      this.form_group.options.push({
        value: key,
        label: key,
      });
    }
  },

  methods: {
    updateReply(val) {
      this.dialogReply = true;
      this.form.msg_en = val.msg_en;
      this.form.msg_cn = val.msg_cn;
      this.form.msg_ar = val.msg_ar;
      this.form.msg_fr = val.msg_fr;
      this.form.msg_in = val.msg_in;
      this.form.msg_ja = val.msg_ja;
      this.form.msg_ko = val.msg_ko;
      this.curReplyIndex = val.pkg__pk;
    },
    addGroup() {
      let params = {
        msg: this.form_group.text,
      };
      params["i"] = this.groupAll[this.form_group.value];
      batchSendMsgs(params).then((res) => {
        this.dialogGroup = false;

        this.form_group.text = "";
        this.$message({
          message: "发送成功",
          type: "success",
        });
      });
      // this.form_group.name = "";
    },
    initReplyData() {
      getAutoReplyList().then((res) => {
        res.info.forEach((item) => {
          this.tableData.forEach((it, index) => {
            if (it.pkg__pk === item.pkg__pk) {
              this.tableData.splice(index, 1, item);
            }
          });
        });
      });
    },
    addReply() {
      let params = {};
      params.p = this.curReplyIndex;
      params.info = Object.assign({}, this.form);
      updateAutoReply(params)
        .then((res) => {
          this.initReplyData();
          this.dialogReply = false;
          this.$message({
            message: "修改成功",
            type: "success",
          });
        })
        .catch((err) => {
          this.$message.error("修改失败，请重试");
        });
    },
    removeGroup(val) {
      this.$confirm("删除该分组也将删除该分组下的所有用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delete this.groupAll[val];
          delete this.groupAllCopy[val]
          
          this.groupAll = Object.assign({}, this.groupAllCopy)
          let params = {
            info: this.groupAll,
          };
          updateSug(params).then((res) => {
            localStorage.setItem("u_g", JSON.stringify(this.groupAll));
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          });
        })
        .catch(() => {});
    },
    removeUser(k, index) {
      this.$confirm("删除该用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.groupAll[k].splice(index, 1);
          let params = {
            info: this.groupAll,
          };
          updateSug(params).then((res) => {
            localStorage.setItem("u_g", JSON.stringify(this.groupAll));
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
#set {
  width: 100%;
  min-height: calc(100vh - 50px);
  padding: 20px;
  background: #eff1f7;
}
h1 {
  font-size: 20px;
  font-weight: 400;
  color: #2c2c2c;
  small {
    margin-left: 15px;
    font-size: 15px;
    color: #777777;
  }
}
.tag {
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);
  background: #ffffff;
}
.group-wrap {
  margin-top: 40px;
}
.group {
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);
  background: #ffffff;
}
.reply-wrap {
  margin-top: 40px;
}
.table-wrap {
  padding: 5px;
  margin-top: 20px;
  border-radius: 4px;
  border: 1px solid #e4e4e4;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);
  background: #ececf1;
}
.group_wrap {
  padding: 20px;
  margin-top: 20px;
  border-radius: 4px;
  border: 1px solid #e4e4e4;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);
}
.group_title {
  font-size: 16px;
  color: #414750;
  font-weight: bold;
  span {
    margin-left: 20px;
    font-size: 14px;
    font-weight: normal;
    color: #f56c6c;
    cursor: pointer;
  }
}
.group_table {
  margin-top: 10px;
  border-radius: 4px;
  border: 1px solid #e4e4e4;
}
.head {
  background: #ececf1;
  color: #414750 !important;
  font-weight: 500;
}
.group_lis {
  display: flex;
  border-bottom: 1px solid #e4e4e4;
  // padding: 10px;
}
.group_lis:last-child {
  border-bottom: none;
}
.group_li {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 280px;
  margin-right: 20px;
  padding: 10px;
  color: #606266;
  font-size: 14px;
  border-right: 1px solid #e4e4e4;
}
.handler {
  color: #f56c6c;
  font-size: 12px;
  cursor: pointer;
}
</style>